import ApiService from "@/services/ApiService";
import axios from "axios";
import store from "@/store";

let at, rt, fromApp;
let clientWeb = {
  client_id: "web",
  Authorization: "Basic d2ViOndlYl9zZWNyZXQ="
};
let clientApp = {
  client_id: "webapp",
  Authorization: "Basic d2ViYXBwOndlYmFwcF9zZWNyZXQ="
};

class LoginService {
  login(username, password) {
    return new Promise((resolve, reject) => {
      //const isFromApp = this.getFromApp();

      const data = {
        grant_type: "password",
        username: username,
        password: password,
        clientId: "web"
      };

      if (!/^\+39/.test(data.username)) {
        data.username = `+39${data.username}`;
      }

      axios({
        method: "post",
        url: ApiService.getApiUrl() + "/sec/v2/oauth/token",
        params: data,
        headers: {
          Authorization: "Basic d2ViYXBwOndlYmFwcF9zZWNyZXQ=",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(response => {
          if (response && response.data && response.data.access_token) {
            this.setAccessToken(response.data.access_token);
            this.setRefreshToken(response.data.refresh_token);
          }
          resolve(response);
        })
        .catch(error => reject(error));
    });
  }

  refreshToken() {
    return new Promise((resolve, reject) => {
      const token = this.getRefreshToken();

      const data = {
        grant_type: "refresh_token",
        refresh_token: token,
        client_id: this.getClientId()
      };

      axios({
        method: "post",
        url: ApiService.getApiUrl() + "/sec/v2/oauth/token",
        params: data,
        headers: {
          Authorization: this.getAuthorization(),
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(response => {
          if (response && response.data && response.data.access_token) {
            this.setAccessToken(response.data.access_token);
            this.setRefreshToken(response.data.refresh_token);
          }

          resolve(response);
        })
        .catch(error => {
          console.log("EXPIRED SESSION ---");
          window.vm.$root.$emit("EXPIRED_SESSION");
          reject(error);
        });
    });
  }

  setAccessToken(accessToken) {
    at = accessToken;
    sessionStorage.setItem("cr_at", accessToken);
    ApiService.setToken(accessToken);
  }
  getAccessToken() {
    return at ? at : sessionStorage.getItem("cr_at");
  }
  removeAccessToken() {
    at = null;
    sessionStorage.removeItem("cr_at");
  }

  setRefreshToken(refreshToken) {
    rt = refreshToken;
    sessionStorage.setItem("cr_rt", refreshToken);
  }
  getRefreshToken() {
    return rt ? rt : sessionStorage.getItem("cr_rt");
  }
  removeRefreshToken() {
    rt = null;
    sessionStorage.removeItem("cr_rt");
  }

  setFromApp() {
    fromApp = true;
    sessionStorage.setItem("fromApp", true);
  }
  getFromApp() {
    return fromApp ? fromApp : sessionStorage.getItem("fromApp");
  }
  getClientId() {
    const client = store?.state?.tokenData["client_id"];
    return client === "web" ? clientWeb.client_id : clientApp.client_id;
  }
  getAuthorization() {
    const client = store?.state?.tokenData["client_id"];
    return client === "web" ? clientWeb.Authorization : clientApp.Authorization;
  }
  removeFromApp() {
    fromApp = null;
    sessionStorage.removeItem("fromApp");
  }
}

export default new LoginService();
